"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JsonToCsv = void 0;
var _react = _interopRequireDefault(require("react"));
var _lib = require("./lib");
var _propTypes = _interopRequireWildcard(require("prop-types"));
var _lodash = require("lodash");
var _exportToExcel = _interopRequireDefault(require("./exportToExcel"));
require("./style.css");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const flatten = require("flat");
const JsonToCsv = props => {
  const {
    columnIndex,
    downloadType,
    json,
    filename,
    filenameWithDateTime,
    moveToFirstPosition,
    removeColumns,
    children,
    handleClick,
    renameHeaders,
    withoutExcelBlock,
    showLimitExceedsToastMsg
  } = props;
  let triggerLimitExceedsToastMsg = false;
  const truncatedColumnList = [];
  const flatJsonArray = [];
  const twoDigitDateTime = val => String(val).padStart(2, "0");
  moveToFirstPosition.reverse();

  /** Return file name with date and time */
  const getCurrentDateTime = filename => {
    const today = new Date();
    const date = "".concat(today.getFullYear(), "-").concat(twoDigitDateTime(today.getMonth() + 1), "-").concat(twoDigitDateTime(today.getDate()));
    const time = "".concat(twoDigitDateTime(today.getHours()), "-").concat(twoDigitDateTime(today.getMinutes()), "-").concat(twoDigitDateTime(today.getSeconds()));
    const dateTime = "".concat(date, "_").concat(time);
    return "".concat(filename, "_").concat(dateTime);
  };

  /** Prepare file name: with date & time OR plain string */
  const prepareFileName = filenameString => {
    const fileNameDateTime = filenameWithDateTime ? getCurrentDateTime(filenameString) : filenameString;
    return fileNameDateTime;
  };

  /** Escape double quote as per RFC-4180 only for CSV downloads */
  const escapeQuotes = literal => literal.replace(/"/g, '""');
  const wrapQuotes = literal => "\"".concat(literal, "\"");
  const escape = column => {
    // Primitive string, process and return early.
    if ((0, _lodash.isString)(column)) {
      return escapeQuotes(column);
    }

    // Not an array, do not process and return early.
    if (!Array.isArray(column)) {
      return column;
    }

    // An array, process as usual.
    const quotedColumn = column.map(element => {
      let escapedLiteral = element;
      if ((0, _lodash.isString)(escapedLiteral) && (0, _lodash.includes)(escapedLiteral, '"')) {
        escapedLiteral = escapeQuotes(escapedLiteral);
      }
      if ((0, _lodash.isString)(escapedLiteral) && ((0, _lodash.includes)(escapedLiteral, ",") || (0, _lodash.includes)(escapedLiteral, '"'))) {
        escapedLiteral = wrapQuotes(escapedLiteral);
      }
      if ((0, _lodash.isString)(escapedLiteral) && (0, _lodash.includes)(escapedLiteral, '"') && downloadType !== "Download as Excel") {
        escapedLiteral = escapeQuotes(escapedLiteral);
      }
      return escapedLiteral;
    });
    return quotedColumn;
  };
  const handleEscape = flatObject => {
    for (const key of Object.keys(flatObject)) {
      flatObject[key] = escape(flatObject[key]);
    }
    return flatObject;
  };

  /** Array of flat objects */
  for (const object in json) {
    let getFlatObject = flatten(json[object], {
      safe: true
    });
    removeColumns.forEach(columnName => {
      delete getFlatObject[columnName];
    });
    moveToFirstPosition.forEach(columnName => {
      const cellValue = getFlatObject[columnName];
      delete getFlatObject[columnName];
      getFlatObject = {
        [columnName]: cellValue,
        ...getFlatObject
      };
    });
    /** Rename column headers */
    if (!(0, _lodash.isEmpty)(renameHeaders)) {
      getFlatObject = Object.keys(getFlatObject).reduce((acc, key) => {
        const renamedObject = {
          [renameHeaders[key] || key]: getFlatObject[key]
        };
        return {
          ...acc,
          ...renamedObject
        };
      }, {});
    }
    getFlatObject = handleEscape(getFlatObject);

    /** Convert values to string for excel representation. */
    for (const item in getFlatObject) {
      /** Conversion of boolean values to string. */
      // console.log(typeof (getFlatObject[item]), getFlatObject);
      if (typeof getFlatObject[item] === "boolean") {
        getFlatObject[item] = getFlatObject[item] ? "true" : "false";
      } else if (Array.isArray(getFlatObject[item])) {
        /** Conversion of array values to string. */
        getFlatObject[item] = getFlatObject[item].toString();
      }
      /** Truncate the string if string length is greater that 32,767 */
      if (!(0, _lodash.isNil)(getFlatObject[item]) && (0, _lodash.get)(getFlatObject, item, "").length > 32767) {
        if (downloadType === "Download as Excel") {
          getFlatObject[item] = getFlatObject[item].substring(0, 32767);
        }
        /* istanbul ignore else */
        if (!truncatedColumnList.includes(item)) {
          truncatedColumnList.push(item);
        }
        triggerLimitExceedsToastMsg = true;
      }
    }
    flatJsonArray.push(getFlatObject);
  }
  if (triggerLimitExceedsToastMsg) {
    showLimitExceedsToastMsg(truncatedColumnList);
  }

  /* Download Excel file */
  if (downloadType === "Download as Excel") {
    const args = {
      data: flatJsonArray,
      columnIndex,
      fileName: "".concat(prepareFileName(filename), ".")
    };
    /** Do not display an additional element in case of Portal usage. */
    /* istanbul ignore else */
    if (withoutExcelBlock) {
      (0, _exportToExcel.default)(args);
      return null;
    }

    /** Display block for storybook example. hence ignoring the below code from coverage */
    /* istanbul ignore next */
    return /*#__PURE__*/_react.default.createElement("a", {
      "aria-label": "excel-download",
      onClick: event => {
        event.preventDefault();
        return flatJsonArray.length ? (0, _exportToExcel.default)(args) : false;
      }
    }, children);
  }

  /* Download Csv file */
  return /*#__PURE__*/_react.default.createElement(_lib.CSVLink, {
    className: "csv--download",
    data: flatJsonArray,
    filename: "".concat(prepareFileName(filename), ".csv"),
    onClick: event => {
      event.preventDefault();
      return flatJsonArray.length ? handleClick(event) : false;
    }
  }, children);
};
exports.JsonToCsv = JsonToCsv;
JsonToCsv.defaultProps = {
  filename: "export",
  filenameWithDateTime: false,
  children: "Export CSV",
  moveToFirstPosition: [],
  removeColumns: [],
  renameHeaders: {},
  columnIndex: [],
  downloadType: "Download as Csv",
  withoutExcelBlock: false,
  handleClick: () => {
    let timerCSV = setTimeout(() => {
      const isHrefAttributes = document.querySelector(".csv--download");
      if (isHrefAttributes) {
        const downloadLink = isHrefAttributes.href;
        const downloadAttr = isHrefAttributes.download;
        const targetValue = isHrefAttributes.target;
        const link = document.createElement("a");
        link.setAttribute("href", downloadLink);
        link.setAttribute("download", downloadAttr);
        link.setAttribute("target", targetValue);
        link.click();
        link.remove();
      }
      clearTimeout(timerCSV);
    }, 250);
  },
  showLimitExceedsToastMsg: () => {}
};
JsonToCsv.propTypes = {
  /** Columns we wish to rename, key would be the original header & value being renamed header. */
  renameHeaders: _propTypes.default.shape(),
  /** Information that needs to be converted to csv. */
  json: _propTypes.default.arrayOf(_propTypes.default.shape()).isRequired,
  /** Columns we wish to move to first position relative to sequence of json prop. */
  moveToFirstPosition: _propTypes.default.arrayOf(_propTypes.string),
  /** Columns we wish to remove from the ones present in json prop. */
  removeColumns: _propTypes.default.arrayOf(_propTypes.string),
  /** Specifies file name */
  filename: _propTypes.default.string,
  /** If file name should include date and time */
  filenameWithDateTime: _propTypes.default.bool,
  /** Look and feel. It can be string/HTML/component like button. */
  children: _propTypes.default.node,
  /** Click handler for CSV button. */
  handleClick: _propTypes.default.func,
  /** Only for Excel download.
   *  Specify column index for column formatting. Specially format column to prevent 'ratio' value
   *  representation in time.
   */
  columnIndex: _propTypes.default.array,
  /** Specify the type of file for download. Support Excel and CSV. */
  downloadType: _propTypes.default.string,
  /** To hide the excel element. Default a button is displayed. */
  withoutExcelBlock: _propTypes.default.bool,
  /** Trigger the toast msg if the char limit for column exceeds */
  showLimitExceedsToastMsg: _propTypes.default.func
};